import { TriangleDownIcon, TriangleUpIcon } from '@chakra-ui/icons';
import { Button, Flex } from '@chakra-ui/react';

type ListReorderButtonsProps = {
    index: number;
    itemCount: number;
    onReorder: (fromIndex: number, toIndex: number) => void;
};

export function ListReorderButtons({ index, itemCount, onReorder }: ListReorderButtonsProps) {
    const moveUp = () => {
        if (index > 0) {
            onReorder(index, index - 1);
        }
    };

    const moveDown = () => {
        if (index < itemCount - 1) {
            onReorder(index, index + 1);
        }
    };

    return (
        <Flex>
            <Button
                backgroundColor="white"
                w="25px"
                minW="25px"
                _hover={{ color: '#ccccbb' }}
                _focus={{ backgroundColor: 'white' }}
                _active={{ backgroundColor: 'white' }}
                color="grey"
                leftIcon={<TriangleUpIcon w="25px" />}
                onClick={moveUp}
            />
            <Button
                backgroundColor="white"
                w="25px"
                minW="25px"
                _hover={{ color: '#ffcccb' }}
                _focus={{ backgroundColor: 'white' }}
                _active={{ backgroundColor: 'white' }}
                color="grey"
                leftIcon={<TriangleDownIcon w="25px" />}
                onClick={moveDown}
            />
        </Flex>
    );
}
